import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

import IconCross from '../../../Icons/IconCross';

import './index.scss';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  content,
  confirmText,
  cancelText,
  theme,
}) => {
  const modalRef = useRef(null);

  const handleClickOutside = event => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  if (isOpen) {
    return ReactDOM.createPortal(
      <div className="confirmation-modal-v3-overlay">
        <div
          className="confirmation-v3-modal"
          role="dialog"
          aria-labelledby="dialog-title"
          aria-modal="true"
          ref={modalRef}
        >
          <div className="confirmation-v3-modal__title">
            <h4>{title}</h4>

            <button
              className="confirmation-v3-modal__close"
              title="close"
              aria-label="Close modal"
              type="button"
              onClick={onClose}
            >
              <IconCross />
            </button>
          </div>

          <div className="confirmation-v3-modal__content">{content}</div>

          <div className="confirmation-v3-modal__footer">
            {cancelText && (
              <button className="cancel" onClick={onClose}>
                {cancelText}
              </button>
            )}
            {confirmText && (
              <button className={`confirm ${theme}`} onClick={onConfirm}>
                {confirmText}
              </button>
            )}
          </div>
        </div>
      </div>,
      document.body,
    );
  }

  return null;
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  theme: PropTypes.oneOf(['red', 'blue']),
};

ConfirmationModal.defaultProps = {
  theme: 'blue',
};

export default ConfirmationModal;
